const doc = [({"ja":({"adminConstantHotelLinkType":({"noneLink":"非表示", "engineLink":"エンジンのみ表示", "allLink":"全て表示"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;